import newSurveyQuestions from '@config/newSurveyQuestions.json'

import type { SurveyParams, SurveyQuestion } from '@lib/types/subscription-box'

export type AnnouncementConfig = {
	enabled: boolean
	text: string
}

const getNewSurvey = (): { survey: SurveyParams; announcement: AnnouncementConfig | null } => {
	const survey: SurveyParams = {
		surveyId: newSurveyQuestions.surveyId,
		surveyQuestions: newSurveyQuestions.questions.map((question, idx) => ({
			id: question.id,
			displayOptions: question.displayOptions,
			type: question.type as SurveyQuestion['type'],
			body: question.body,
			isRequired: question.isRequired,
			surveyAnswerOptions: question.options.map((option, optionIdx) => ({
				id: idx * 100 + optionIdx + 1,
				optionLabel: option.label ?? '',
				optionValue: option.value,
				optionImage: option.image || null,
				position: optionIdx + 1,
				status: 'enabled'
			}))
		}))
	}

	const announcement = newSurveyQuestions.announcement?.enabled
		? newSurveyQuestions.announcement
		: null

	return { survey, announcement }
}

export default getNewSurvey
